import emailjs from "emailjs-com";
import React from 'react';

export default () => {

    function sendEmail(e) {
        e.preventDefault();

    emailjs.sendForm(
            process.env.EMAIL_SERVICE_ID, 
            process.env.EMAIL_TAMPLATE, 
            e.target, 
            process.env.EMAIL_USER_ID
        )
        .then((result) => {
            console.log(result.text);
        }, (error) => {
            console.log(error.text);
        });
        e.target.reset()
    }

    return(
        <div>
            <div className="contact-container">
                <form onSubmit={sendEmail}>
                    <p><h4>It’s what relationships are made of</h4></p>
                    <span>
                        Del-La-Chef is not only a restaurant, here we are like a family, 
                        a lot of friends gethering together not only to enjoy good food & music, 
                        Del-La-Chef is like home for us, we invite you to come and join us.
                    </span>
                    <div className="row pt-5 mx-auto" 
                         style={{'min-width': '-webkit-fill-available'}}
                    >
                        <div className="col-8 form-group mx-auto">
                            <input 
                                type="text" 
                                className="form-control reaquired" 
                                placeholder="Name" 
                                name="name" 
                                reaquired 
                            />
                        </div>
                        <div className="col-8 form-group pt-2 mx-auto">
                            <input 
                                type="email" 
                                className="form-control reaquired" 
                                placeholder="Email Address"
                                name="email" 
                                reaquired 
                             />
                        </div>
                        <div className="col-8 form-group pt-2 mx-auto">
                            <input 
                                type="text" 
                                className="form-control reaquired" 
                                placeholder="Password" 
                                name="password" 
                                reaquired 
                            />
                        </div>
                        <div className="col-8 form-group pt-2 mx-auto">
                            <input 
                                type="text" 
                                className="form-control reaquired" 
                                placeholder="Confirm Password"
                                name="confirmPassword" 
                                reaquired 
                             />
                        </div>
                        <div className="col-8 pt-3 mx-auto">
                            <input 
                                type="submit" 
                                className="btn-primary" 
                                value="join" 
                            />
                        </div>
                    </div>
                </form>
            </div>
        </div>
    )
}